import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceRowMetadata  {
    _originalTypeClassName = "zERP.BO.InvoiceRowMetadata";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceRowMetadata.translate = translateService;
}
this.MakeAssetAcquisition = false;
this.CreateMultipleAssets = false;
this.AssetsSerialNumber = null;
this.InvoiceRowMetadataKey = null;
this._key = this.InvoiceRowMetadataKey = 0; 
}

static translate: TranslateService;
_key: any;
MakeAssetAcquisition:any;
CreateMultipleAssets:any;
AssetsSerialNumber:any;
ParentAsset:any;
Department:any;
private _InvoiceRowMetadataKey:any;
get InvoiceRowMetadataKey(): any {
    return this._InvoiceRowMetadataKey;
  }
set InvoiceRowMetadataKey(value: any) {
    this._InvoiceRowMetadataKey = value;
    this._key = value;
  }
static setParentAsset = ($this, value) => {
var oldValue = $this.ParentAsset;
$this.ParentAsset = value;
if (value != null) {
}
}
static setDepartment = ($this, value) => {
var oldValue = $this.Department;
$this.Department = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceRowMetadataKey == null || $this.InvoiceRowMetadataKey == 0;
            }


}